import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import { loadParticipantConsentDetails } from "../../../../Redux/actions/providerConsentAction";
import ConsentBlockWrapper from "./ConsentBlockWrapper";
import { Backdrop, Typography } from "@mui/material";
import { resetConsentState } from "../../../../Redux/reducers/providerConsentSlice";
import ConsentFormEmpty from "./ConsentFormEmpty";
import ConsentFormHeader from "./ConsentFormHeader";
import { useQuery } from "../../../../utils/hooks";
import Loader from "../../../Common/assets/Loader";
import { styled } from "@mui/material/styles";

const CBMessageWrapper = styled("div")(() => ({
  height: "calc(100vh - 80px)",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const CBArea = styled("div")({
  height: "calc(100vh - 80px)",
  display: "flex",
  alignItems: "start",
  padding: "8px",
});

const ConsentForm: React.FC = () => {
  const { id: consentId } = useParams();
  const versionId = useQuery().get("versionId");
  const studyId = useQuery().get("studyId");

  const dispatch = useAppDispatch();

  const loading = useAppSelector((state) => state.providerConsent.loading);
  const error = useAppSelector((state) => state.providerConsent.error);
  const blocks = useAppSelector((state) => state.providerConsent.blocks);

  useEffect(() => {
    if (studyId && versionId)
      dispatch(loadParticipantConsentDetails(studyId, consentId, versionId));
    return () => {
      dispatch(resetConsentState());
    };
  }, [dispatch, studyId, versionId, consentId]);

  return (
    <div className="preview-wrapper participant-consent">
      {loading && (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      )}
      <ConsentFormHeader />
      {error ? (
        <CBMessageWrapper>
          <Typography variant="h5" color="grey">
            {error}
          </Typography>
        </CBMessageWrapper>
      ) : (
        <CBArea style={{ padding: "0px" }}>
          {loading ? null : blocks.length === 0 ? (
            <ConsentFormEmpty />
          ) : (
            <ConsentBlockWrapper />
          )}
        </CBArea>
      )}
    </div>
  );
};

export default ConsentForm;
